/*
 * @Author: liujunhong
 * @Date: 2023/7/5
 * @Desc: 更换绑定APP
 */

import React, { Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react';
import Nav from '@/components/Nav';
import Title from '@/components/Title';
import Step from '@/components/Step';
import ErrorTips from '@/components/ErrorTips';
import { getFirstConditions, getSecondConditions } from '@/pages/changeBindApp/const';
import BaseForm from '@/components/BaseForm';
import './index.less';
import { BIND_PHONE_STATUS, MAP_SITE_URL, RESPONSE_STATUS } from '@/constants';
import useSWR from 'swr';
import { getAccountInfo } from '@/constants/api';
import { useOutletContext } from 'react-router-dom';
import { changeNewPhone, checkOldPhone } from '@/services/authPhone';
import { Form } from 'antd';
import SuccessTips from '@/components/SuccessTips';
import { LoginInfo } from '@/types';
import { fetcher } from '@/utils/request';
import { useSetAtom } from 'jotai';
import { loginAtom } from '@/utils/atoms';

const TITLE_ICON = 'url(//img.gyyxcdn.cn/security/commons/images/account/tcacc.gif) no-repeat -3px 2px';
export const STEPS_MAP = [
  {
    title: '验证原绑定APP',
  },
  {
    title: '认证新APP',
  },
  {
    title: '更换成功',
  },
];

interface StepProps {
  setCurrent?: Dispatch<SetStateAction<number>>;
  setErrorTips: Dispatch<SetStateAction<string>>;
}

export interface StepFirstProps extends StepProps {
  authedPhone?: string;
  setUpdateLogin?: Dispatch<SetStateAction<Object>>;
  loginInfo?: LoginInfo;
}

const StepFirst = (props: StepFirstProps) => {
  const {setErrorTips, setCurrent, setUpdateLogin, authedPhone, loginInfo} = props;
  const conditions = getFirstConditions({setUpdateLogin, authedPhone, setErrorTips, loginInfo});

  const onFinish = async (values: any) => {
    const {verifyCode} = values;
    const res = await checkOldPhone({verifyCode, phone: authedPhone});
    if (res.retCode !== RESPONSE_STATUS.SUCCESS) {
      setErrorTips(res.message);
      return;
    }
    setCurrent?.(1);
  };

  return <BaseForm conditions={conditions} onFinish={onFinish}/>;
};


const StepSecond = (props: StepFirstProps) => {
  const {setErrorTips, setCurrent} = props;
  const [form] = Form.useForm();
  const mobile = Form.useWatch('phone', form);

  const conditions = getSecondConditions({mobile, setErrorTips});
  const onFinish = async (values: any) => {
    const {phone, verifyCode} = values;

    const res = await changeNewPhone({verifyCode, phone});

    if (res.retCode !== RESPONSE_STATUS.SUCCESS) {
      setErrorTips(res.message);
      return;
    }

    setCurrent?.(2);
  };

  return <BaseForm form={form} conditions={conditions} onFinish={onFinish}/>;
};


const Index = () => {
  const [current, setCurrent] = useState(0);
  const [errorTips, setErrorTips] = useState('');
  const loginInfo: LoginInfo = useOutletContext();
  const setUpdateLogin = useSetAtom(loginAtom);


  useEffect(() => {
    if (!loginInfo?.isLogin) {
      setUpdateLogin({isLogin: false, visibleLogin: true});
    }
  }, [loginInfo?.isLogin]);

  useEffect(() => {
    if (current) {
      setErrorTips('');
    }
  }, [current]);

  const swrKey = Object.keys(loginInfo).length ? `${getAccountInfo}?isWeGame=${loginInfo.isWeGame}` : null;

  const {data: res} = useSWR(swrKey, fetcher, {
    revalidateOnFocus: false,
  });


  const renderComponent: Record<string, ReactNode> = {
    0: <StepFirst setErrorTips={setErrorTips} setUpdateLogin={setUpdateLogin} setCurrent={setCurrent}
                  authedPhone={res?.data?.authedPhone} loginInfo={loginInfo}/>,
    1: <StepSecond setErrorTips={setErrorTips} setCurrent={setCurrent}/>,
    2: <SuccessTips href="/" id="text_change_app_success" title="更换绑定APP成功！"
                    jumpText={'首页'}/>,
  };


  return <div className="we_change_app ">
    <Nav activeMenu={'accountManagement'}/>
    <div className="main_center wrap">
      <Title background={TITLE_ICON} title="更换绑定APP"></Title>
      {
        res?.data?.bindPhoneStatus === BIND_PHONE_STATUS.UNBIND && <div className="un_bind_wrap">
          <img src="//img.gyyxcdn.cn/security/commons/images/error.png" alt=""/>
          您末绑定光宇APP，无法使用此功能，请前往此处绑定。 （APP介绍地址：<a
          href="//we.gyyx.cn/hdzt/hd/p/gd/app/index.html">http://we.gyyx.cn/hdzt/hd/p/gd/app/index.html</a>)
        </div>
      }
      {res?.data?.bindPhoneStatus !== BIND_PHONE_STATUS.UNBIND && <>
        {errorTips && <ErrorTips content={errorTips}/>}
        <Step stepsMap={STEPS_MAP} current={current}></Step>
        {renderComponent[current]}
        <div className="tips_wrap">
          <p className="tips_title">温馨提示：</p>
          <p>1，短信到达可能需要2-3分钟，若您长时间未收到短信，建议您点击重发短信。</p>
          <p>2，当您手机号有丢失或不再使用该手机号码请主动联系<a href={`${MAP_SITE_URL.DEFAULT_URL}/kf`}>在线客服</a></p>
        </div>
      </>}

    </div>
  </div>;
};
export default Index;
